<template>
  <nav id="sidebar-nav" class="sidebar-nav" ref="sidebar-nav">
    <div class="OnlySideBar OutsideCss">

      <nav :class="[this.$route.path === '/dashboard' ? 'cg-menu-lateral' : 'cg-menu-lateral estreito']">
        <div class="cg-menu-logo">
          <a href="https://www.cognatis.com.br" class="logo" target="_blank">&nbsp;</a>
        </div>
        <ul class="cg-menu-apps">
          <li :class="[this.$route.path === '/dashboard' ? 'start selected' : 'start']">
            <a href="javascript:void(0)" @click="Dashboard()">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>Início</h5>
              </div>
            </a>
          </li>
          <li :class="appClass(1, 'nettool', 'home')">
            <a href="javascript:void(0)" @click="Home()" id="btnNettoolPRO">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>NETtool<sup>&reg;</sup> Pro</h5>
                <p v-if="this.isAppActive(1)">Ativo</p>
                <p v-if="!this.isAppActive(1)">Voc&ecirc; ainda n&atilde;o ativou a NETtool. Quer saber como isso pode
                  beneficiar sua empresa?</p>
              </div>
            </a>
          </li>
          <li class="mappoint" :class="appClass(2, 'mappoint')">
            <a href="javascript:void(0)" @click="MapPoint()">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>MAPpoint</h5>
                <p v-if="this.isAppActive(2)">Ativo</p>
                <p v-if="!this.isAppActive(2)">Voc&ecirc; ainda n&atilde;o ativou a MAPpoint. Quer saber como isso pode
                  beneficiar sua empresa?</p>
              </div>
            </a>
          </li>
          <li :class="appClass(4, 'apidados')">
            <a href="javascript:void(0)" @click="Apidados">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>API de dados</h5>
                <p v-if="this.isAppActive(4)">Ativo</p>
                <p v-if="!this.isAppActive(4)">Voc&ecirc; ainda n&atilde;o ativou a API de Dados. Quer saber como isso
                  pode beneficiar sua empresa?</p>
              </div>
            </a>
          </li>
          <li :class="appClass(5, 'smartleads')">
            <a href="javascript:void(0)">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>SmartLeads</h5>
                <p v-if="!this.isAppActive(5)">Voc&ecirc; ainda n&atilde;o ativou o SmartLeads. Quer saber como isso
                  pode beneficiar sua empresa?</p>
              </div>
            </a>
          </li>
        </ul>
        <ul class="cg-menu-apps">
          <li
            :class="[(this.$route.path === '/flow-sources' || this.$route.path === '/datalead') ? 'consumo selected' : 'consumo']">
            <a href="javascript:void(0)" @click="DataLead">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>Consumo de Dados Premium</h5>
                <p>Ativo</p>
              </div>
            </a>
          </li>
          <li :class="[this.$route.path === '/upload' ? 'upload selected' : 'upload']">
            <a id="btnUpload" href="javascript:void(0)" @click="Uploads()">
              <span class="highlight"></span>
              <span class="icone"></span>
              <div class="txt">
                <h5>Upload</h5>
              </div>
            </a>
          </li>
        </ul>
        <ul class="cg-menu-servico">
          <li :class="appClass(6, 'helpdesk')">
            <a href="https://cognatis.screenstepslive.com/s/13101" title="Helpdesk" target="_blank" rel="noopener">
              <div>
                <span class="icone"></span>
                <div class="txt">
                  <h5>Helpdesk</h5>
                </div>
              </div>
            </a>
          </li>

          <li class="logout">
            <a @click="LogOff()" title="Logout">
              <div>
                <span class="icone"></span>
                <div class="txt">
                  <h5>Logout</h5>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </nav>

      <div class="sidebar-container" v-if="false">
        <b-row class="sidebar-row">
          <b-col align-self="center" style="padding-top: 15px;">
            <b-navbar-brand href="home">
              <img src="../images/coglogo/Cognatis-menu-rgb.png" height="38" alt="BV">
            </b-navbar-brand>
          </b-col>

          <b-col cols="12" align-self="center"><span class="separator"></span></b-col>

          <nav class="user-nav sidebar-nav-itens" v-if="false">
            <li>
              <b-btn id="navButton1" class="button1 collapsed nav-item no-padding" @mouseover="hoverIn('button1')"
                @mouseout="hoverOut('button1')"
                v-b-popover.hover.left="{ customClass: 'menu-class', content: renderedUserText }">
                <b-container>
                  <b-row>
                    <svg width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="button1" fill-rule="evenodd" clip-rule="evenodd"
                        d="M7 6C7.79565 6 8.55871 5.68393 9.12132 5.12132C9.68393 4.55871 10 3.79565 10 3C10 2.20435 9.68393 1.44129 9.12132 0.87868C8.55871 0.316071 7.79565 0 7 0C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3C4 3.79565 4.31607 4.55871 4.87868 5.12132C5.44129 5.68393 6.20435 6 7 6ZM0 15C-1.36979e-08 14.0807 0.18106 13.1705 0.532843 12.3212C0.884626 11.4719 1.40024 10.7003 2.05025 10.0503C2.70026 9.40024 3.47194 8.88463 4.32122 8.53284C5.1705 8.18106 6.08075 8 7 8C7.91925 8 8.82951 8.18106 9.67879 8.53284C10.5281 8.88463 11.2997 9.40024 11.9497 10.0503C12.5998 10.7003 13.1154 11.4719 13.4672 12.3212C13.8189 13.1705 14 14.0807 14 15H0Z"
                        fill="#6A707C" />
                    </svg>
                  </b-row>
                </b-container>
              </b-btn>
            </li>



          </nav>

          <b-col align-self="center"><span class="separator"></span></b-col>
        </b-row>
      </div>

      <!-- <b-col cols="12" align-self="center"><span class="separator"></span></b-col> -->

      <nav class="sidebar-nav-itens" v-if="false">


        <li>
          <b-btn id="navButton3" class="button5 nav-item no-padding" @click="Home()" @mouseover="hoverIn('button5')"
            @mouseout="hoverOut('button5')" v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Mapas' }">
            <b-container>
              <b-row>
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 0.585938L6 4.58594V17.4139L10 13.4139V0.585938ZM1.707 2.29294C1.56715 2.15313 1.38898 2.05792 1.19503 2.01935C1.00108 1.98079 0.800045 2.00059 0.617345 2.07626C0.434646 2.15193 0.278483 2.28007 0.168598 2.44448C0.0587141 2.60889 4.22243e-05 2.80219 0 2.99994V12.9999C5.66374e-05 13.2651 0.105451 13.5194 0.293 13.7069L4 17.4139V4.58594L1.707 2.29294ZM15.707 4.29294L12 0.585938V13.4139L14.293 15.7069C14.4328 15.8467 14.611 15.942 14.805 15.9805C14.9989 16.0191 15.2 15.9993 15.3827 15.9236C15.5654 15.8479 15.7215 15.7198 15.8314 15.5554C15.9413 15.391 16 15.1977 16 14.9999V4.99994C15.9999 4.73474 15.8945 4.48043 15.707 4.29294Z"
                    fill="#F58026" />
                </svg>
              </b-row>
            </b-container>
          </b-btn>
        </li>
        <li>
          <b-btn v-if="false" class="button4 collapsed nav-item no-padding" @click="debug"
            @mouseover="hoverIn('button4')" @mouseout="hoverOut('button4')"
            v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Início' }">
            <b-container>
              <b-row>
                <i class="fa-solid fa-database"></i>
              </b-row>
            </b-container>
          </b-btn>
        </li>



      </nav>

      <b-col v-if="false" cols="12" align-self="center"><span class="separator"></span></b-col>
      <nav v-if="false" class="user-nav sidebar-nav-itens">
        <li>
          <b-btn id="navButton2" class="button2 collapsed nav-item no-padding" @click="Uploads()"
            @mouseover="hoverIn('button2')" @mouseout="hoverOut('button2')"
            v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Uploads' }">
            <b-container>
              <b-row>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.4998 13.0003C4.60432 12.9991 3.74336 12.6548 3.09407 12.0381C2.44478 11.4214 2.05655 10.5793 2.00928 9.68508C1.96201 8.79086 2.25928 7.91252 2.83993 7.23082C3.42058 6.54911 4.24044 6.1159 5.1308 6.02031C4.86863 4.9922 5.02562 3.90205 5.56722 2.98969C6.10883 2.07732 6.99068 1.41748 8.0188 1.15531C9.04691 0.893143 10.1371 1.05013 11.0494 1.59174C11.9618 2.13334 12.6216 3.0152 12.8838 4.04331C13.4952 3.95817 14.1177 3.99976 14.7124 4.16547C15.307 4.33119 15.8613 4.6175 16.3406 5.00659C16.8199 5.39568 17.214 5.87923 17.4984 6.42716C17.7828 6.97508 17.9514 7.57567 17.9938 8.19156C18.0361 8.80745 17.9513 9.42547 17.7446 10.0072C17.5379 10.5889 17.2137 11.1218 16.7921 11.5729C16.3706 12.0239 15.8608 12.3834 15.2944 12.629C14.728 12.8745 14.1171 13.0009 13.4998 13.0003H10.9998V9.41331L12.2928 10.7063C12.4814 10.8885 12.734 10.9893 12.9962 10.987C13.2584 10.9847 13.5092 10.8795 13.6946 10.6941C13.88 10.5087 13.9852 10.2579 13.9875 9.99571C13.9897 9.73351 13.889 9.48091 13.7068 9.29231L10.7068 6.29231C10.5193 6.10484 10.265 5.99952 9.9998 5.99952C9.73463 5.99952 9.48032 6.10484 9.2928 6.29231L6.2928 9.29231C6.11064 9.48091 6.00984 9.73351 6.01212 9.99571C6.0144 10.2579 6.11957 10.5087 6.30498 10.6941C6.49039 10.8795 6.7412 10.9847 7.00339 10.987C7.26559 10.9893 7.51819 10.8885 7.7068 10.7063L8.9998 9.41431V13.0003H5.4998Z"
                    fill="#6A707C" />
                  <path
                    d="M9 13H11V18C11 18.2652 10.8946 18.5196 10.7071 18.7071C10.5196 18.8946 10.2652 19 10 19C9.73478 19 9.48043 18.8946 9.29289 18.7071C9.10536 18.5196 9 18.2652 9 18V13Z"
                    fill="#6A707C" />
                </svg>
              </b-row>
            </b-container>
          </b-btn>
        </li>

        <li>
          <b-btn class="button3 collapsed nav-item no-padding" @mouseover="hoverIn('button3')" @click="toggleModal"
            @mouseout="hoverOut('button3')" v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Consumo' }">
            <b-container>
              <b-row>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.83333 9.99968L8.33333 7.49967L10.8333 9.99968L14.1667 6.66634M2.5 3.33301H17.5M6.66667 17.4997L10 14.1663L13.3333 17.4997H6.66667ZM3.33333 3.33301H16.6667V13.333C16.6667 13.554 16.5789 13.766 16.4226 13.9223C16.2663 14.0785 16.0543 14.1663 15.8333 14.1663H4.16667C3.94565 14.1663 3.73369 14.0785 3.57741 13.9223C3.42113 13.766 3.33333 13.554 3.33333 13.333V3.33301Z"
                    stroke="#6A707C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </b-row>
            </b-container>
          </b-btn>
        </li>
      </nav>






      <nav class="sidebar-nav-itens">
        <li v-if="false">
          <!--        -->
          <b-btn id="popover-button-7" class="button7 collapsed nav-item no-padding" @click="FiltroBasico()"
            @mouseover="hoverIn('button7')" @mouseout="hoverOut('button7')"
            v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Filtro Básico de Empresas' }">
            <b-container>
              <b-row>
                <svg style="margin-left:2px;" width="14" height="16" viewBox="0 0 14 16" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1 2C1 1.46957 1.21071 0.960859 1.58579 0.585786C1.96086 0.210714 2.46957 0 3 0H11C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2V14C13.2652 14 13.5196 14.1054 13.7071 14.2929C13.8946 14.4804 14 14.7348 14 15C14 15.2652 13.8946 15.5196 13.7071 15.7071C13.5196 15.8946 13.2652 16 13 16H10C9.73479 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V13C9 12.7348 8.89464 12.4804 8.70711 12.2929C8.51957 12.1054 8.26522 12 8 12H6C5.73478 12 5.48043 12.1054 5.29289 12.2929C5.10536 12.4804 5 12.7348 5 13V15C5 15.2652 4.89464 15.5196 4.70711 15.7071C4.51957 15.8946 4.26522 16 4 16H1C0.734784 16 0.48043 15.8946 0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15C0 14.7348 0.105357 14.4804 0.292893 14.2929C0.48043 14.1054 0.734784 14 1 14V2ZM4 3H6V5H4V3ZM6 7H4V9H6V7ZM8 3H10V5H8V3ZM10 7H8V9H10V7Z"
                    fill="#6A707C" />
                </svg>
              </b-row>
            </b-container>
          </b-btn>
        </li>
        <li v-if="isCog">

          <div class="cog" :style="{ backgroundColor: cogColor }" @mouseover="showText = true"
            @mouseleave="showText = false">
            <span v-if="showText">{{ envTag }} - {{ EnvironmentAlias }} </span>
          </div>

        </li>

        <!--      <li>-->
        <!--        <b-btn id="popover-button-8" class="button8 collapsed nav-item no-padding" @mouseover="hoverIn('button8')" @mouseout="hoverOut('button8')" >-->
        <!--          <b-container>-->
        <!--            <b-row>-->
        <!--              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--              <path d="M0 8C0 7.73478 0.105357 7.48043 0.292893 7.29289C0.48043 7.10536 0.734783 7 1 7H3C3.26522 7 3.51957 7.10536 3.70711 7.29289C3.89464 7.48043 4 7.73478 4 8V13C4 13.2652 3.89464 13.5196 3.70711 13.7071C3.51957 13.8946 3.26522 14 3 14H1C0.734783 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V8ZM6 4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H9C9.26522 3 9.51957 3.10536 9.70711 3.29289C9.89464 3.48043 10 3.73478 10 4V13C10 13.2652 9.89464 13.5196 9.70711 13.7071C9.51957 13.8946 9.26522 14 9 14H7C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13V4ZM12 1C12 0.734784 12.1054 0.48043 12.2929 0.292893C12.4804 0.105357 12.7348 0 13 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H13C12.7348 14 12.4804 13.8946 12.2929 13.7071C12.1054 13.5196 12 13.2652 12 13V1Z" fill="#6A707C"/>-->
        <!--              </svg>-->
        <!--            </b-row>-->
        <!--          </b-container>-->
        <!--        </b-btn>-->

        <!--         <b-popover customClass='menu-class' target="popover-button-8" triggers="hover focus" placement="left">-->
        <!--          <template #title>GeoPop</template>-->
        <!--            <nav class="dropdown-box">-->
        <!--              <li class="item-filter-basico">-->
        <!--                <a class="dropdown-box-item" href="#"><span class="link">Home</span></a>-->
        <!--              </li>-->
        <!--              <li class="item-filter-basico">-->
        <!--                <a class="dropdown-box-item" href="#"><span class="link">Supply</span></a>-->
        <!--              </li>-->
        <!--              <li class="item-filter-basico">-->
        <!--                <a class="dropdown-box-item" href="#"><span class="link">People</span></a>-->
        <!--              </li>-->
        <!--              <li class="item-filter-basico">-->
        <!--                <a class="dropdown-box-item" href="#"><span class="link">Consumo</span></a>-->
        <!--              </li>-->
        <!--              <li class="item-filter-basico">-->
        <!--                <a class="dropdown-box-item" href="#"><span class="link">Day</span></a>-->
        <!--              </li>-->
        <!--            </nav>-->
        <!--        </b-popover>-->

        <!--    </li>-->

        <!--    <li>-->
        <!--      <b-btn id="popover-button-9" class="button9 collapsed nav-item no-padding" @mouseover="hoverIn('button9')" @mouseout="hoverOut('button9')" >-->
        <!--        <b-container>-->
        <!--          <b-row>-->
        <!--            <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--            <path d="M12 3C12 3.79565 11.6839 4.55871 11.1213 5.12132C10.5587 5.68393 9.79565 6 9 6C8.20435 6 7.44129 5.68393 6.87868 5.12132C6.31607 4.55871 6 3.79565 6 3C6 2.20435 6.31607 1.44129 6.87868 0.87868C7.44129 0.316071 8.20435 0 9 0C9.79565 0 10.5587 0.316071 11.1213 0.87868C11.6839 1.44129 12 2.20435 12 3ZM17 5C17 5.53043 16.7893 6.03914 16.4142 6.41421C16.0391 6.78929 15.5304 7 15 7C14.4696 7 13.9609 6.78929 13.5858 6.41421C13.2107 6.03914 13 5.53043 13 5C13 4.46957 13.2107 3.96086 13.5858 3.58579C13.9609 3.21071 14.4696 3 15 3C15.5304 3 16.0391 3.21071 16.4142 3.58579C16.7893 3.96086 17 4.46957 17 5ZM13 12C13 10.9391 12.5786 9.92172 11.8284 9.17157C11.0783 8.42143 10.0609 8 9 8C7.93913 8 6.92172 8.42143 6.17157 9.17157C5.42143 9.92172 5 10.9391 5 12V15H13V12ZM5 5C5 5.53043 4.78929 6.03914 4.41421 6.41421C4.03914 6.78929 3.53043 7 3 7C2.46957 7 1.96086 6.78929 1.58579 6.41421C1.21071 6.03914 1 5.53043 1 5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3C3.53043 3 4.03914 3.21071 4.41421 3.58579C4.78929 3.96086 5 4.46957 5 5ZM15 15V12C15.0014 10.9833 14.7433 9.98303 14.25 9.094C14.6933 8.98054 15.1568 8.96984 15.6049 9.06272C16.053 9.15559 16.474 9.34959 16.8357 9.62991C17.1974 9.91023 17.4903 10.2695 17.6921 10.6802C17.8939 11.091 17.9992 11.5424 18 12V15H15ZM3.75 9.094C3.25675 9.98305 2.9986 10.9833 3 12V15H2.6572e-07V12C-0.000192468 11.542 0.104463 11.0901 0.305947 10.6789C0.507431 10.2676 0.800394 9.90793 1.16238 9.62742C1.52437 9.3469 1.94578 9.15298 2.39431 9.06052C2.84284 8.96806 3.30658 8.97951 3.75 9.094Z" fill="#6A707C"/>-->
        <!--            </svg>-->
        <!--          </b-row>-->
        <!--        </b-container>-->
        <!--      </b-btn>-->

        <!--      <b-popover customClass='menu-class' target="popover-button-9" triggers="hover focus" placement="left">-->
        <!--        <template #title>Pessoas</template>-->
        <!--          <nav class="dropdown-box">-->
        <!--            <li class="item-filter-basico">-->
        <!--              <a class="dropdown-box-item" href="#"><span class="link">Filtro Básico</span></a>-->
        <!--            </li>-->
        <!--          </nav>-->
        <!--      </b-popover>-->

        <!--   </li>-->
      </nav>

      <nav class="user-nav sidebar-nav-itens">
        <!--    <li>-->
        <!--      <b-btn class="button10 collapsed nav-item no-padding" @mouseover="hoverIn('button10')" @mouseout="hoverOut('button10')" v-b-popover.hover.left="{ customClass: 'menu-class', content: 'Filtro Avançado' }" @click="AdvancedFilter()">-->
        <!--        <b-container>-->
        <!--          <b-row align-v="center">-->
        <!--            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V4C13.9999 4.26519 13.8946 4.51951 13.707 4.707L9 9.414V13C8.99994 13.2652 8.89455 13.5195 8.707 13.707L6.707 15.707C6.56715 15.8468 6.38898 15.942 6.19503 15.9806C6.00108 16.0192 5.80005 15.9993 5.61735 15.9237C5.43465 15.848 5.27848 15.7199 5.1686 15.5555C5.05871 15.391 5.00004 15.1978 5 15V9.414L0.293 4.707C0.105451 4.51951 5.66374e-05 4.26519 0 4V1Z" fill="#6A707C"/>-->
        <!--            </svg>-->
        <!--          </b-row>-->
        <!--        </b-container>-->
        <!--      </b-btn>-->
        <!--    </li>-->

      </nav>
    </div>
    <b-modal ref="my-modal" hide-footer size="xl" title="Consumo">
      <div class="d-block text-center">
        <LeadManager v-if="showLeadManager" />
      </div>
    </b-modal>
  </nav>
</template>

<script>
import Vue from 'vue'
import LeadManager from '@/components/datalead/LeadManager.vue';
import { Auth } from '../service/Auth'


export default {

  name: 'sidebar-nav',
  components: {
    LeadManager,
  },
  data: () => ({
    authservice: Auth.build({}),
    applications: [],
    showLeadManager: false,
    Username: Vue.prototype.$foundation.getCurrentUser(),
    Environment: Vue.prototype.$foundation.getEnvironmentName(),
    EnvironmentId: Vue.prototype.$foundation.getEnvironmentId(),
    UserText: Vue.prototype.$foundation.getCurrentUser() + '<br>' + Vue.prototype.$foundation.getEnvironmentName(),
    EnvironmentAlias: '',
    isCog: true, // Define se o círculo deve ser exibido
    showText: false, // Define se o texto deve ser exibido
    cogColor: '', // Cor do círculo
    envTag: '',
    CognatisId: 2
  }),
  methods: {
    /**
       * Verifica se um determinado tipo de aplicação existe no array de aplicações.
       *
       * @param {number} type - O tipo da aplicação a ser verificado. Deve ser um dos valores abaixo:
       *
       * AppTypes:
       * 1 - NettoolPRo
       * 2 - Mappoint (Cli)
       * 3 - Dashboard (integrado)
       * 4 - API
       * 5 - Smartleads
       * 6 - HelpDesk
       *
       * @returns {boolean} - Retorna `true` se o tipo existir no array, caso contrário, retorna `false`.
       */
    LogOff() {
      // this.$emit('beforeExit')
      document.cookie = 'ssoSessionKey=; Max-Age=-99999999; path=/';
      sessionStorage.clear()
      localStorage.clear()
      this.$session.destroy()
      window.location.href = 'https://cognatis.com.br/';
      // this.$router.push('/')
    },
    debug(e) {
      console.log('debug')
      console.log(e)
    },
    toggleModal() {
      this.$gtag.event("tela_consumo", {
        event_category: "Interações Plataforma",
        event_label: "Exibição de Consumo",
        value: 1
      });

      this.showLeadManager = true
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    Dashboard() {
      this.$router.push('/dashboard')
    },
    Home() {
      const userData = {
        userId: Vue.prototype.$foundation.getTokenClaims()['UserId'],          // ID do usuário no seu banco
        environmentId: Vue.prototype.$foundation.getEnvironmentId()  // ID do ambiente/cliente que ele logou
      };

      this.$gtag.event("start_nettoolpro", {
        event_category: "Interações Plataforma",
        event_label: "Abertura do NettoolPro",
        value: 1,
        ...userData
      });


      if (this.isAppActive(1)) {
        this.$router.push('/home')
      }
    },
    Apidados() {
      if (this.isAppActive(4)) {
        let applications = this.applications.filter(item => item.config.type === 4);
        let apiUrl = applications[0].baseUrl;
        window.open(apiUrl, "_blank");
      }
      // this.$router.push('/apidados')
    },
    ComprarDados() {
      this.$router.push('/flow-sources')
    },
    FiltroBasico() {
      this.$router.push('/empresas/filtro-basico')
    },
    Uploads() {
      this.$router.push('/upload')
    },
    MapPoint() {
      const userData = {
        userId: Vue.prototype.$foundation.getTokenClaims()['UserId'],          // ID do usuário no seu banco
        environmentId: Vue.prototype.$foundation.getEnvironmentId()  // ID do ambiente/cliente que ele logou
      };

      this.$gtag.event("start_mappoint", {
        event_category: "Interações Plataforma",
        event_label: "Abertura do MapPoint",
        value: 1,
        ...userData
      });
      if (this.isAppActive(2)) this.$router.push('/mappoint')
    },
    AdvancedFilter() {
      this.$router.push('/advancedfilter')
    },
    DataLead() {
      this.$router.push('/datalead')
    },
    hoverIn(item) {
      document.querySelector('.' + item).classList.add('colorir')
      // eslint-disable-next-line no-undef
      // $('.' + item).addClass('colorir')
    },
    hoverOut(item) {
      // eslint-disable-next-line no-undef
      // $('.' + item).removeClass('colorir')
      document.querySelector('.' + item).classList.toggle('colorir')
    },
    darkMode() {
      document.querySelector('.sidebar-nav').classList.add('darkmode')
    },
    lightMode() {
      document.querySelector('.sidebar-nav').classList.toggle('darkmode')
    }

  },
  computed: {
    enviromentName() {
      return Vue.prototype.$foundation.getEnvironmentName();
    },
    hasModal() {
      try {
        const modal = this.$refs['my-modal'].$el;
        const isVisible = modal.classList.contains('show');
        return isVisible
      } catch (erro) {
        return false
      }
    },
    renderedUserText() {
      return `${this.Username} em ${this.Environment}`;
    },
    popoverConfig() {
      // Both title and content specified as a function in this example
      // and will be called the each time the popover is opened
      return {
        html: true,
        title: () => {
          // Note this is called only when the popover is opened
          return '<b>Empresa:</b> '
        },
        content: () => {
          // Note this is called only when the popover is opened
          return '<a class="dropdown-box-item" href="#"><span class="link" @click="FiltroBasico()">Filtro de Empresas</span></a>'
        }
      }
    },
    /**
    * Função que verifica se o tipo da aplicação está presente em `applications.data`.
    * @param {number|string} type - O tipo da aplicação que estamos buscando.
    * @returns {boolean} - Retorna `true` se a aplicação do tipo for encontrada.
    */
    isAppActive() {
      return (type) => {
        // Garante que applications e data existem antes de acessar
        if (!this.applications || !Array.isArray(this.applications)) {
          return false; // Retorna falso caso as applications ou data estejam ausentes
        }

        // Verifica se há algum item com o tipo correspondente em `data`
        return this.applications.some(item =>
          item.config && item.config.type === type // A comparação de tipos precisa ser feita corretamente
        );
      };
    },

    /**
     * Retorna as classes dinâmicas baseadas no tipo da aplicação e no estado da rota.
     * @param {number|string} type - O tipo da aplicação que estamos verificando.
     * @param {string} baseClass - A classe base para a aplicação.
     * @returns {Object} - Objeto de classes dinâmicas a serem aplicadas no componente.
     */
    appClass() {
      return (type, baseClass, otherClass = null) => ({
        [baseClass]: true, // Define a classe base
        'selected': otherClass != null ? this.$route.path === `/${otherClass}` : this.$route.path === `/${baseClass}`, // Adiciona 'selected' se a rota for a mesma
        'app-found': this.isAppActive(type), // Aplica 'app-found' se o tipo for encontrado
        'inativo': !this.isAppActive(type) // Aplica 'inativo' se o tipo não for encontrado
      });
    }
  },
  created() {

  },
  async mounted() {
    const aplications = await this.authservice.getApplication(this.enviromentName);
    if (aplications.status == 200 && aplications.data.length != 0) {
      this.applications = aplications.data
      this.$store.commit('app/setApplications', this.applications)
    } else {
      this.applications = []
      this.$store.commit('app/setApplications', this.applications)
    }
    console.log("SidNaveBar")
    const currentUrl = window.location.hostname;

    // Define a cor do círculo e o texto com base na URL
    switch (currentUrl) {
      case currentUrl.includes('prd'):
        this.cogColor = 'green';
        this.envTag = 'PRD';
        break;
      case currentUrl.includes('hml'):
        this.cogColor = 'yellow';
        this.envTag = 'HML';
        break;
      case currentUrl.includes('dev'):
        this.cogColor = 'red';
        this.envTag = 'DEV';
      default:
        this.cogColor = 'red';
        this.envTag = 'DEV';
    }

    //Feito apenas para não aparecer o nome incorreto
    //e limitar apenas para usuarios cog
    //Temporario - Remover futuramente
    this.EnvironmentAlias = this.EnvironmentId == this.CognatisId ? "Cognatis" : this.Environment
    if (this.EnvironmentId != this.CognatisId)
      this.isCog = false
  }
}
</script>

<style lang="css">
.cog {
  position: fixed;
  bottom: 20px;
  left: 20px;
  /* Alterado para 'left' */
  width: 20px;
  /* Tamanho do círculo */
  height: 20px;
  /* Tamanho do círculo */
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  /* Tamanho do círculo */
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.cog span {
  display: none;
  position: absolute;
  bottom: 20px;
  /* Posição do texto */
  left: 50%;
  /* Alterado para 'left' */
  transform: translateX(-50%);
  /* Ajuste para centralizar o texto */
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 5px;
}

.cog:hover span {
  display: block;
}
</style>
